import { render } from "./IconSkillith.vue?vue&type=template&id=b0a4bfa4"
import script from "./IconSkillith.vue?vue&type=script&lang=js"
export * from "./IconSkillith.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__